import moment from 'moment';

/**
 * Format the payment deadline for display, preserving the timezone offset encoded in the
 * `expirationDate` string (frontline rendered `expiration_time` in the payment's own `time_zone`).
 * `moment.parseZone` keeps that original offset instead of converting to the viewer's local time.
 *
 * @param {string} [expirationDate] - ISO expiration date from the payment payload.
 * @returns {{ date: string, time: string }} Localized date (`LL`) and 24h time (`HH:mm`), or empty
 *   strings when no expiration date is present.
 */
export function formatDeadline(expirationDate) {
  if (!expirationDate) return { date: '', time: '' };
  const parsed = moment.parseZone(expirationDate);
  return {
    date: parsed.format('LL'),
    time: parsed.format('HH:mm'),
  };
}

/**
 * Read an i18n array via `returnObjects`, falling back to an empty array when the key is missing.
 * Shared by the vouchers, which render their instruction/condition lists from array keys.
 *
 * @param {Function} t - The i18next translate function.
 * @param {string} key - The translation key holding an array.
 * @returns {string[]} The translated array, or [].
 */
export function tArray(t, key) {
  const value = t(key, { returnObjects: true });
  return Array.isArray(value) ? value : [];
}

/**
 * Group a reference string in blocks of four characters separated by dashes (OXXOPay style),
 * mirroring frontline's `reference.scan(/.{1,4}/).join('-')`.
 *
 * @param {string} [reference] - The payment reference.
 * @returns {string} The dash-grouped reference, or '' when absent.
 */
export function groupReference(reference) {
  if (!reference) return '';
  return String(reference)
    .match(/.{1,4}/g)
    .join('-');
}
